import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AffinityGroupFilter from "../../../AG/AffinityGroup/AffinityGroupFilter";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useVariantColumns from "../Hooks/useVariantColumns";
import NewVariantModal from "../Modal/NewVariantModal";

const Variants = () => {
  const dispatch = useDispatch();
  const { variantColumns } = useVariantColumns();
  const variantData = useSelector((state) => state.product.selectedProduct.variant.variantData);
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);

  const totalRows = variantData ? variantData.length : 0;

  return (
    <div>
      {/* <div onClick={getSideBarData}></div> */}
      <CommonHeader
        title={"Product"}
        newButton={true}
        // formLink="/prod/product/create"
        deletebtn={true}
        buttonTitle={"New Variant"}
        filterComponent={<AffinityGroupFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={variantColumns}
          data={variantData}
          // apiTabData={apiTabData}
          //   paginatedApi
          //   filterApi
          //   filterApiEntity={"AGRP"}
          //   filterApiListEntity={"AGRP"}
          //   filterApiFunction={setAffinityGroupData}
          //   filterApiService={getListing}
          // filterForm={true}
          totalRows={totalRows}
          // status={"ALL"}
          // statusColumn={"status"}
          // download
          // handleDownload={handleDownload}
          hideTabs
        />
      </div>
      {(modalShow || editShow) && <NewVariantModal />}
    </div>
  );
};

export default Variants;